import { Icon } from '@iconify/react';
import { isNativePlatform } from '@/utils/capacitor';
import { useRegisterOverlay } from '@/contexts/OverlayStackContext';
import { hasSeenPushPrompt } from '@/utils/pushPrompt';

interface PushPermissionSheetProps {
  open: boolean;
  onAllow: () => void;
  onLater: () => void;
}

export function shouldShowPushPrompt({
  isAuthenticated,
  authLoading,
}: {
  isAuthenticated: boolean;
  authLoading: boolean;
}): boolean {
  if (!isNativePlatform() || authLoading || !isAuthenticated) {
    return false;
  }
  return !hasSeenPushPrompt();
}

export function PushPermissionSheet({ open, onAllow, onLater }: PushPermissionSheetProps) {
  useRegisterOverlay(open, onLater);

  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/50" onClick={onLater}>
      <div
        className="w-full max-w-md bg-white rounded-t-3xl px-5 pt-3 pb-safe-4 shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex justify-center mb-4">
          <div className="w-12 h-1.5 bg-gray-300 rounded-full" />
        </div>
        <div className="w-14 h-14 rounded-2xl bg-orange-50 text-[#FC480D] flex items-center justify-center mb-4">
          <Icon icon="ph:bell-bold" className="w-7 h-7" />
        </div>
        <h2 className="text-xl font-bold text-[#0E1726]">Notifikasi booking & mabar</h2>
        <p className="mt-2 text-sm text-gray-500 leading-relaxed">
          Izinkan notifikasi supaya kamu tidak ketinggalan konfirmasi booking, pengingat mabar, dan
          update komunitas.
        </p>
        <button
          type="button"
          onClick={onAllow}
          className="mt-5 w-full h-12 rounded-2xl bg-[#FC480D] text-white font-bold text-sm active:scale-[0.98] active:opacity-90 transition-transform"
        >
          Izinkan
        </button>
        <button
          type="button"
          onClick={onLater}
          className="mt-2 w-full h-12 rounded-2xl text-gray-500 font-semibold text-sm active:scale-[0.98] active:opacity-80 transition-transform"
        >
          Nanti
        </button>
      </div>
    </div>
  );
}
